// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_0a630202","outerContainer":"_1d303e81","secondaryToolbar":"c8b1ab5d","doorHangerRight":"be04d751","toolbarContainer":"_3c5922de","toolbarViewerMiddle":"_6d2b68bd","progressBar":"da67026c","back-to-application":"_53998c19","Card":"_00d4421c","CardLogo":"_8cc56460","CardWrapper":"c5314ffc","CardContent":"_45ff7201","CardBody":"_7e23377d","CardActions":"_06908063","CardTitle":"b192c523","CardSubTitle":"_5175738f","CardSubContent":"_96651079","CardText":"_3fcb0af1","CardInfo":"_184eaca2","CardInfo-item":"c6ab2f28"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Communities/Components/CommunityCard/styles.styl
// module id = 4930
// module chunks = 39